import { Button, Icon, PlainButton, Popover, PopoverContent, Truncated } from '@customerio/pluma-components/react';
import { FeatureFlag, useFeatureFlag } from '@/services/auth/feature-flags';
import { useAuth } from '@/services/auth';
import * as styles from './index.css';
import { useState } from 'react';
import clsx from 'clsx';

export function AccountSwitcher() {
  const [isOpen, setIsOpen] = useState(false);
  const is2026LayoutRefresh = useFeatureFlag(FeatureFlag.LayoutRefresh2026);
  const auth = useAuth();

  const _handleSwitchAccount = (_index: number) => {
    // TODO(multi-account-switcher): implement
    setIsOpen(false);
  };

  const handleAddAccount = async () => {
    // TODO(multi-account-switcher): implement
    setIsOpen(false);
  };

  return (
    <Popover isOpen={isOpen} onOpenChange={setIsOpen} placement="bottom-start" withArrow={false}>
      {(context) => (
        <>
          {is2026LayoutRefresh ? (
            <Button
              ref={context.reference.setReference}
              {...context.reference.getReferenceProps()}
              size="sm"
              variant="subtle"
              className={styles.accountSwitcherButton}
            >
              <Truncated color="base" text="product-pxs-active">
                {auth.account.name}
              </Truncated>
              <Icon name="chevron-toggle" />
            </Button>
          ) : (
            <PlainButton
              ref={context.reference.setReference}
              {...context.reference.getReferenceProps()}
              pl="125"
              className={clsx(styles.accountSwitcherButton, styles.accountSwitcherButtonOldUI)}
            >
              <Truncated color="invert" text="product-pxs-active">
                {auth.account.name}
              </Truncated>
              <Icon name="chevron-toggle" size="sm" color="subtle" />
            </PlainButton>
          )}
          <PopoverContent>
            <section>
              <PlainButton display="flex" alignItems="center" gap="050" onClick={handleAddAccount}>
                <Icon name="add" />
                Add another account
              </PlainButton>
            </section>
          </PopoverContent>
        </>
      )}
    </Popover>
  );
}
